import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { SecondmentCard } from "../../../Services/PublicSecondments";
import { firmProfilePath, logoUrl } from "../secondmentsDisplay";

interface SecondmentsCardProps {
  card: SecondmentCard;
  posting: boolean;
}

export default function SecondmentsCard({ card, posting }: SecondmentsCardProps): ReactElement {
  const firmHref = posting
    ? `/secondments?view=1&action=view&secid=${card.secId}&firm=${card.firmId}`
    : `/secondments?action=search&firm=${card.firmId}#view`;
  return (
    <article className="secondments-card">
      <div className="secondments-card-grid">
        <a href={firmProfilePath(card.companyType, card.companyNameSlug, card.firmId)}>
          {card.logoName ? <img className="secondments-logo" src={logoUrl(card.logoName)} alt="" /> : null}
        </a>
        <div>
          <div className="text-right">
            <Link className="secondments-overview-link" to={firmHref}>{posting ? "Details" : "Overview"}</Link>
          </div>
          {card.title ? <p className="secondments-meta">{card.title}</p> : null}
          <h3 className="secondments-firm">
            <Link to={firmHref}>{card.companyName}</Link>
          </h3>
          {card.placeLabel ? <p className="secondments-meta">{card.placeLabel}</p> : null}
          {posting && card.location ? <p className="secondments-meta">Location(s): {card.location}</p> : null}
          {card.excerpt ? <p>{card.excerpt}</p> : null}
        </div>
      </div>
    </article>
  );
}
